import { BaseBrush } from './BaseBrush';
import { Grid } from '../Grid';
import { Stone } from '../particles/Stone';
import { Gravel } from '../particles/Gravel';
import { Sawdust } from '../particles/Sawdust';

export class Crusher extends BaseBrush {
    name = 'crusher';

    protected applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void {
        const particle = grid.get(x, y);
        if (!particle || particle.empty) return;

        // 如果被胶水固定，解除固定，恢复自由下落
        if (particle.props.isGlued) {
            particle.props.isGlued = false;
            return;
        }

        // 越靠近中心，粉碎概率越大
        const probability = 1 - (dist / (maxDist + 1));
        if (Math.random() > probability) return;

        // 粉碎逻辑
        if (particle.name === 'Stone') {
            // 石头 -> 碎石
            grid.set(x, y, new Gravel({ temperature: particle.temperature }));
        } else if (particle.name === 'Wood') {
            // 木头 -> 木屑
            grid.set(x, y, new Sawdust({ temperature: particle.temperature }));
        }
    }
}
